import { connect } from "react-redux";
import { list_orders } from "../../redux/actions/orders";
import { get_items, get_total, get_item_total } from "../../redux/actions/cart";
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router";
import { countries } from "../../helpers/fixedCountries";
import { update_user_profile } from "../../redux/actions/profile";
import { InfinitySpin } from "react-loader-spinner";
import SideNav from "../../components/dashboard/Sidebar";
import { logout } from "../../redux/actions/auth";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "../../components/helpers/cropImageHelper";
import { Dialog, Transition } from "@headlessui/react";

const DashboardProfile = ({
  list_orders,
  get_items,
  get_total,
  get_item_total,
  isAuthenticated,
  user,
  update_user_profile,
  profile,
}) => {
  const [loading, setLoading] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    get_items();
    get_total();
    get_item_total();
    list_orders();
  }, []);

  const [formData, setFormData] = useState({
    address_line_1: profile?.address_line_1 || "",
    address_line_2: profile?.address_line_2 || "",
    city: profile?.city || "",
    state_province_region: profile?.state_province_region || "",
    zipcode: profile?.zipcode || "",
    phone: profile?.phone || "",
    country_region: profile?.country_region || "Colombia",
  });

  const {
    address_line_1,
    address_line_2,
    city,
    state_province_region,
    zipcode,
    phone,
    country_region,
  } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSelectImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(URL.createObjectURL(file));
      setIsModalOpen(true);
    }
  };

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const onCropImage = async () => {
    try {
      const cropped = await getCroppedImg(selectedImage, croppedAreaPixels);
      setCroppedImage(cropped);
      setSelectedImage(null);
      setIsModalOpen(false);
    } catch (e) {
      console.error(e);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formDataToSubmit = new FormData();
    if (address_line_1)
      formDataToSubmit.append("address_line_1", address_line_1);
    if (address_line_2)
      formDataToSubmit.append("address_line_2", address_line_2);
    if (city) formDataToSubmit.append("city", city);
    if (state_province_region)
      formDataToSubmit.append("state_province_region", state_province_region);
    if (zipcode) formDataToSubmit.append("zipcode", zipcode);
    if (phone) formDataToSubmit.append("phone", phone);
    if (country_region)
      formDataToSubmit.append("country_region", country_region);

    if (croppedImage) {
      const response = await fetch(croppedImage);
      const blob = await response.blob();
      formDataToSubmit.append("photo", blob, "profile.jpg");
    }

    try {
      await update_user_profile(formDataToSubmit);
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  if (!isAuthenticated) return <Navigate to="/" />;

  return (
    <SideNav>
      <main className="flex-1">
        <div className="py-6">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <form onSubmit={(e) => onSubmit(e)} className="max-w-3xl mx-auto">
              <div className="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                  Perfil
                </h3>
              </div>

              <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5 ">
                <label
                  htmlFor="address_line_1"
                  className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                >
                  Direccion Principal:
                </label>
                <div className="mt-1 sm:mt-0 sm:col-span-2">
                  <div className="max-w-lg flex rounded-md shadow-sm">
                    <input
                      type="text"
                      name="address_line_1"
                      placeholder={`${
                        profile.address_line_1
                          ? profile.address_line_1
                          : "Ingresa tu direccion principal"
                      }`}
                      onChange={(e) => onChange(e)}
                      value={address_line_1}
                      className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>
              </div>

              <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5 mt-2">
                <label
                  htmlFor="address_line_2"
                  className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                >
                  Direccion Secundaria(Opcional):
                </label>
                <div className="mt-1 sm:mt-0 sm:col-span-2">
                  <div className="max-w-lg flex rounded-md shadow-sm">
                    <input
                      type="text"
                      name="address_line_2"
                      placeholder={`${
                        profile.address_line_2
                          ? profile.address_line_2
                          : "Ingresa tu direccion secundaria"
                      }`}
                      onChange={(e) => onChange(e)}
                      value={address_line_2}
                      className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>
              </div>

              <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5 mt-2">
                <label
                  htmlFor="city"
                  className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                >
                  Ciudad:
                </label>
                <div className="mt-1 sm:mt-0 sm:col-span-2">
                  <div className="max-w-lg flex rounded-md shadow-sm">
                    <input
                      type="text"
                      name="city"
                      placeholder={`${
                        profile.city ? profile.city : "Ingresa tu ciudad"
                      }`}
                      onChange={(e) => onChange(e)}
                      value={city}
                      className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>
              </div>

              <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5 mt-2">
                <label
                  htmlFor="state_province_region"
                  className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                >
                  Departamento o Region:
                </label>
                <div className="mt-1 sm:mt-0 sm:col-span-2">
                  <div className="max-w-lg flex rounded-md shadow-sm">
                    <input
                      type="text"
                      name="state_province_region"
                      placeholder={`${
                        profile.state_province_region
                          ? profile.state_province_region
                          : "Ingresa tu departamento o region"
                      }`}
                      onChange={(e) => onChange(e)}
                      value={state_province_region}
                      className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>
              </div>

              <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5 mt-2">
                <label
                  htmlFor="zipcode"
                  className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                >
                  Zona Postal:
                </label>
                <div className="mt-1 sm:mt-0 sm:col-span-2">
                  <div className="max-w-lg flex rounded-md shadow-sm">
                    <input
                      type="text"
                      name="zipcode"
                      placeholder={`${
                        profile.zipcode
                          ? profile.zipcode
                          : "Ingresa tu zona postal"
                      }`}
                      onChange={(e) => onChange(e)}
                      value={zipcode}
                      className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>
              </div>

              <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5 mt-2">
                <label
                  htmlFor="phone"
                  className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                >
                  Numero de Telefono:
                </label>
                <div className="mt-1 sm:mt-0 sm:col-span-2">
                  <div className="max-w-lg flex rounded-md shadow-sm">
                    <input
                      type="text"
                      name="phone"
                      placeholder={`${
                        profile.phone
                          ? profile.phone
                          : "Ingresa tu numero de telefono"
                      }`}
                      onChange={(e) => onChange(e)}
                      value={phone}
                      className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>
              </div>

              <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5 mt-2">
                <label
                  htmlFor="country_region"
                  className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                >
                  Pais
                </label>
                <div className="mt-1 sm:mt-0 sm:col-span-2">
                  <select
                    id="country_region"
                    name="country_region"
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    onChange={(e) => onChange(e)}
                  >
                    <option value={country_region}>
                      {profile.country_region}
                    </option>
                    {countries &&
                      countries.map((country, index) => (
                        <option key={index} value={country.name}>
                          {country.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="mt-4">
                <label className="block text-sm font-medium text-gray-700">
                  Imagen de Perfil
                </label>
                {croppedImage ? (
                  <img
                    src={croppedImage}
                    alt="Imagen recortada"
                    className="mt-4 w-32 h-32 rounded-full object-cover"
                  />
                ) : (
                  <img
                    src={`${process.env.REACT_APP_API_URL}${profile.photo}`}
                    alt="Imagen de perfil"
                    className="mt-4 w-32 h-32 rounded-full object-cover"
                  />
                )}
                <input
                  type="file"
                  accept="image/*"
                  onChange={onSelectImage}
                  className="mt-2"
                />
              </div>

              {/* Submit Button */}
              {loading ? (
                <button className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded">
                  <InfinitySpin
                    type="Oval"
                    width={20}
                    height={20}
                    color="#fff"
                  />
                </button>
              ) : (
                <button
                  type="submit"
                  className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded"
                >
                  Guardar
                </button>
              )}
            </form>
          </div>
        </div>
      </main>
      <Transition show={isModalOpen} as={React.Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto"
          onClose={() => setIsModalOpen(false)}
        >
          <div className="flex items-center justify-center min-h-screen">
            <Dialog.Panel className="bg-white rounded-lg p-6 shadow-lg">
              <Dialog.Title className="text-lg font-medium text-gray-900">
                Recortar Imagen
              </Dialog.Title>
              <div className="relative w-96 h-96 mt-4">
                <Cropper
                  image={selectedImage}
                  crop={crop}
                  zoom={zoom}
                  aspect={1}
                  onCropChange={setCrop}
                  onZoomChange={setZoom}
                  onCropComplete={onCropComplete}
                />
              </div>
              <div className="mt-4 flex justify-end space-x-4">
                <button
                  onClick={onCropImage}
                  className="px-4 py-2 bg-indigo-600 text-white rounded"
                >
                  Guardar
                </button>
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="px-4 py-2 bg-gray-300 rounded"
                >
                  Cancelar
                </button>
              </div>
            </Dialog.Panel>
          </div>
        </Dialog>
      </Transition>
    </SideNav>
  );
};

const mapStateToProps = (state) => ({
  orders: state.Orders.orders,
  isAuthenticated: state.Auth.isAuthenticated,
  user: state.Auth.user,
  profile: state.Profile.profile,
});

export default connect(mapStateToProps, {
  list_orders,
  get_items,
  get_total,
  get_item_total,
  update_user_profile,
  logout,
})(DashboardProfile);
